module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C109"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "P20"
  }, [_vm._v("The notion of distributed cognition, central to the posthuman as it is defined in this book, makes acknowledging intellectual and practical contributions to this project an inevitability as well as a pleasure. The arguments have benefited from conversations and correspondence with many friends and colleagues, among them Evelyn Fox Keller, Felicity Nussbaum, Rob Latham, Adalaide Morris, Brooks Landon, Peter Galison, Timothy Lenoir, Sandra Harding, Sharon Traweek, and Marjorie Luesebrink. Mark Poster and an anonymous reader for the University of Chicago Press gave valuable suggestions for revisions and rethinking parts of the argument. Tom Ray, Rodney Brooks, and Mark Tilden graciously spoke with me about their artificial life projects, and Stefan Helmreich shared with me an early version of his book on artificial life. Many of my students gave valuable feedback and criticism of early versions of my ideas, including Carol Wald, Jim Berkley, Kevin Fisher, Evan Nisonson, Mark Sander, Linda Whitford, and Jill Galvin.")]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_vm._v("I am also very grateful for the institutional support I have received, including a fellowship from the Guggenheim Foundation, a fellowship from the Stanford Humanities Center, a Presidential Research Fellowship from the University of California, support from the Council on Research at the University of California at Los Angeles, and a leave of absence and research support from the University of Iowa. I could not have completed this project without this generous support.")])]), _c('p', {
    staticClass: "P21"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("I owe a debt of gratitude as well to Routledge Press for allowing me to reprint “Narratives of Artificial Life,” from "), _c('em', [_vm._v("FutureNatural: Nature, Science, Culture")]), _vm._v(", edited by George Robertson, Melinda Mash, Lisa Tickner, John Bird, Barry Curtis, and Tim Putnam, pp. 145–46, © 1996 (appearing in revised form as ")]), _c('span', {
    attrs: {
      "href": "#/html/15_9__Narratives_of_Artificial_Life#page_222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v("); and “Designs on the Body: Cybernetics, Nor"), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("bert Wiener, and the Play of Metaphor,” from "), _c('em', [_vm._v("History of the Human Sciences")]), _vm._v(" 3 (1990): 212–28 (appearingin revised from as a portion of ")]), _c('span', {
    attrs: {
      "href": "#/html/10_4__Liberal_Subjectivity_Imperile#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v("). Johns Hopkins University Press has graciously allowed me to reprint three articles appearing in "), _c('em', [_vm._v("Configurations: A Journal of Literature, Science, and Technology—")]), _vm._v("“The Materiality of Informatics,” "), _c('em', [_vm._v("Configurations")]), _vm._v(" 1 (1993): 147–70 (appearing in revised form as a portion of "), _c('span', {
    attrs: {
      "href": "#/html/14_8__The_Materiality_of_Informatic#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 8")]), _vm._v("); “Boundary Disputes: Homeostasis, Reflexivity, and the Foundations of Cybernetics,” ibid. 3 (1994): 441–67 (appearing in revised form as part of "), _c('span', {
    attrs: {
      "href": "#/html/09_3__Contesting_for_the_Body_of_In#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v("); and “The Posthuman Body: Inscription and Incorporation in "), _c('em', [_vm._v("Galatea")]), _vm._v(" 2.2 and "), _c('em', [_vm._v("Snow Crash,”")]), _vm._v(" ibid. 5 (1997): 241–66 (appearing as part of "), _c('span', {
    attrs: {
      "href": "#/html/16_10__The_Semiotics_of_Virtuality#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 10")]), _vm._v("). MIT Press has given permission to reprint “Virtual Bodies and Flickering Signifiers,” from "), _c('em', [_vm._v("October")]), _vm._v(" 66 (Fall 1993): 69–91 (appearing in slightly revised form as "), _c('a', {
    attrs: {
      "href": "#/html/08_2__Virtual_Bodies_and_Flickering#page_25"
    }
  }, [_vm._v("chapter 2")]), _vm._v("). The University of North Carolina Press has given permission to reprint a portion of “Voices Out of Bodies, Bodies Out of Voices,” from "), _c('em', [_vm._v("Sound States: Innovative Poetics and Acoustical Technologies")]), _vm._v(", edited by Adalaide Morris, pp. 74–78, 86–96, © 1997 by The University of North Carolina Press (appearing in revised form as a part of "), _c('span', {
    attrs: {
      "href": "#/html/14_8__The_Materiality_of_Informatic#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 8")]), _vm._v("). "), _c('em', [_vm._v("The Journal of the Fantastic in the Arts")]), _vm._v(" has given permission to reprint “Schizoid Android: Cybernetics and the Mid-60s Novels of Dick,” "), _c('em', [_vm._v("JFIA")]), _vm._v(" 8 (1997): 419–42 (appearing in slightly revised form as "), _c('span', {
    attrs: {
      "href": "#/html/12_6__The_Second_Wave_of_Cybernetic#page_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "P21"
  }, [_vm._v("Finally, my greatest debt is to my family, who have listened patiently to my ideas over the years, and to my husband, Nick Gessler, from whom I have learned more than I can say.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e6be0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Acknowledgments.vue
// module id = 69
// module chunks = 0